export default "__VITE_ASSET__BWS_dgEW__"